import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Tooltip } from '@knockrentals/knock-shared-web';
import TitleWithTooltip from './Components/TitleWithTooltip';
import {
  AI_LEASING_COLUMN_NAMES as COLUMN_NAMES,
  AI_LEASING_FIELDS as FIELDS,
  AI_LEASING_TOOL_TIPS as TOOL_TIPS,
} from './constants';

const getTooltip = (rowData) =>
  rowData.leasingEnabled ? '' : 'AI Leasing Product not active';

const getAILeasingColumns = ({
  isAiNurtureEnabled,
  saveVaData,
  saveAiEmail,
}) => {
  const tableArray = [
    {
      title: 'Properties',
      width: '120px',
      field: 'propertyName',
      cellStyle: {
        position: 'sticky',
        left: 0,
        zIndex: 3,
        backgroundColor: '#fff',
      },
      headerStyle: {
        left: '0px',
        zIndex: 4,
      },
    },
    {
      title: TitleWithTooltip(COLUMN_NAMES[FIELDS.IS_CHAT_ENABLED]),
      tooltip: TOOL_TIPS[FIELDS.IS_CHAT_ENABLED],
      field: FIELDS.IS_CHAT_ENABLED,
      width: '100px',
      render: (rowData) => {
        return (
          <Tooltip title={getTooltip(rowData)}>
            <span>
              <Switch
                checked={!!rowData.is_chat_enabled}
                color="primary"
                disabled={!rowData.leasingEnabled}
                onChange={(event) =>
                  saveVaData(
                    rowData,
                    FIELDS.IS_CHAT_ENABLED,
                    event.target.checked,
                  )
                }
              />
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: TitleWithTooltip(COLUMN_NAMES[FIELDS.IS_SMS_ENABLED]),
      tooltip: TOOL_TIPS[FIELDS.IS_SMS_ENABLED],
      field: FIELDS.IS_SMS_ENABLED,
      width: '100px',
      render: (rowData) => {
        return (
          <Tooltip title={getTooltip(rowData)}>
            <span>
              <Switch
                checked={!!rowData.is_sms_enabled}
                color="primary"
                disabled={!rowData.leasingEnabled}
                onChange={(event) =>
                  saveVaData(
                    rowData,
                    FIELDS.IS_SMS_ENABLED,
                    event.target.checked,
                  )
                }
              />
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: TitleWithTooltip(COLUMN_NAMES[FIELDS.IS_VOICE_ENABLED]),
      tooltip: TOOL_TIPS[FIELDS.IS_VOICE_ENABLED],
      field: FIELDS.IS_VOICE_ENABLED,
      width: '100px',
      render: (rowData) => {
        return (
          <Tooltip title={getTooltip(rowData)}>
            <span>
              <Switch
                checked={!!rowData.is_voice_enabled}
                color="primary"
                disabled={!rowData.leasingEnabled}
                onChange={(event) =>
                  saveVaData(
                    rowData,
                    FIELDS.IS_VOICE_ENABLED,
                    event.target.checked,
                  )
                }
              />
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: TitleWithTooltip(COLUMN_NAMES[FIELDS.IS_AI_EMAIL_ENABLED]),
      tooltip: TOOL_TIPS[FIELDS.IS_AI_EMAIL_ENABLED],
      field: FIELDS.IS_AI_EMAIL_ENABLED,
      width: '100px',
      render: (rowData) => {
        return (
          <Tooltip title={getTooltip(rowData)}>
            <span>
              <Switch
                checked={rowData[FIELDS.IS_AI_EMAIL_ENABLED] === 'ON'}
                color="primary"
                disabled={!rowData.leasingEnabled}
                onChange={(event) => saveAiEmail(rowData, event.target.checked)}
              />
            </span>
          </Tooltip>
        );
      },
    },
    ...(isAiNurtureEnabled
      ? [
          {
            title: TitleWithTooltip(COLUMN_NAMES[FIELDS.IS_AI_NURTURE_ENABLED]),
            tooltip: TOOL_TIPS[FIELDS.IS_AI_NURTURE_ENABLED],
            field: FIELDS.IS_AI_NURTURE_ENABLED,
            width: '100px',
            render: (rowData) => (
              <Tooltip title={getTooltip(rowData)}>
                <span>
                  <Switch
                    checked={!!rowData.is_ai_nurture_enabled}
                    color="primary"
                    disabled={!rowData.leasingEnabled}
                    onChange={(event) => {
                      const { checked: isChecked } = event.target;
                      const shouldBindResidentNurtureValue = !isChecked;

                      if (shouldBindResidentNurtureValue) {
                        rowData[FIELDS.IS_RESIDENT_AI_NURTURE_ENABLED] =
                          isChecked;
                      }

                      saveVaData(
                        rowData,
                        FIELDS.IS_AI_NURTURE_ENABLED,
                        isChecked,
                      );
                    }}
                  />
                </span>
              </Tooltip>
            ),
          },
        ]
      : []),
    {
      title: TitleWithTooltip(COLUMN_NAMES[FIELDS.PNA_VA_ENABLED]),
      tooltip: TOOL_TIPS[FIELDS.PNA_VA_ENABLED],
      field: FIELDS.PNA_VA_ENABLED,
      width: '100px',
      render: (rowData) => {
        return (
          <Switch
            checked={!!rowData.pna_va_enabled}
            color="primary"
            onChange={(event) =>
              saveVaData(rowData, FIELDS.PNA_VA_ENABLED, event.target.checked)
            }
          />
        );
      },
    },
    {
      title: TitleWithTooltip(COLUMN_NAMES[FIELDS.SCHEDULE_TOUR_VA_ENABLED]),
      tooltip: TOOL_TIPS[FIELDS.SCHEDULE_TOUR_VA_ENABLED],
      field: FIELDS.SCHEDULE_TOUR_VA_ENABLED,
      width: '100px',
      cellStyle: {
        textAlign: 'center',
        paddingRight: '70px',
      },
      render: (rowData) => {
        return (
          <Switch
            checked={!!rowData.schedule_tour_va_enabled}
            color="primary"
            onChange={(event) =>
              saveVaData(
                rowData,
                FIELDS.SCHEDULE_TOUR_VA_ENABLED,
                event.target.checked,
              )
            }
          />
        );
      },
    },
  ];
  return tableArray;
};

export { getAILeasingColumns, getTooltip };

getAILeasingColumns.propTypes = {
  isAiNurtureEnabled: PropTypes.bool.isRequired,
  saveVaData: PropTypes.func.isRequired,
  saveAiEmail: PropTypes.func.isRequired,
};
